// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_CalculaDiasUteisInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /plano_metas/calcula_dias_uteis
 *
 * Validates business days calculation requests. Used to preview the number
 * of working days for a given period, optionally considering franchise's
 * weekend opening settings.
 */
import { registerContract } from './validate'

export interface PlanoMetas_CalculaDiasUteisInput {
data_inicial: string
data_final: string
franquia_id?: number
}

registerContract('PlanoMetas_CalculaDiasUteisInput', {
  data_inicial: { type: 'string',  required: true },
  data_final:   { type: 'string',  required: true },
  franquia_id:  { type: 'number',  required: false },
})
